import { Modal } from "antd";
import { useSelector } from "react-redux";
import "./shareModal.scss";
import facebookIcon from "../../../assets/icons/facebook-logo.svg";
import twitterIcon from "../../../assets/icons/twitter.svg";
import instagramIcon from "../../../assets/icons/instagram.svg";
import starIcon from "../../../assets/icons/star-blue.svg";
import { shareCertificateRequest } from "../../../utils/apis/account";

const ShareModal = ({ isOpen, onClose, certificateUrl, certificateTitle, certificateId }) => {
    const idToken = useSelector((state) => state.auth.idToken);

    const handleShare = async (platform) => {
        let shareUrlToUse = certificateUrl;

        // Call the share API if certificate has an ID (works for both regular and lifetime certificates)
        if (certificateId) {
            try {
                const response = await shareCertificateRequest(idToken, certificateId);

                // Use the URL from the API response if available
                if (response && response.url) {
                    shareUrlToUse = response.url;
                }
            } catch (error) {
                console.error(error);
            }
        }

        const shareUrl = encodeURIComponent(shareUrlToUse);
        const shareText = encodeURIComponent(`Check out my ${certificateTitle} certificate!`);

        let url = "";
        switch (platform) {
            case "twitter":
                url = `https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`;
                break;
            case "instagram":
                // Try to open Instagram app first, fallback to web
                const instagramUrl = `instagram://`;
                const instagramWebUrl = `https://www.instagram.com/`;

                // Try to open Instagram app
                window.location.href = instagramUrl;

                // Fallback to web after a short delay if app doesn't open
                setTimeout(() => {
                    window.open(instagramWebUrl, "_blank");
                }, 500);

                // Copy link to clipboard for user convenience
                navigator.clipboard.writeText(shareUrlToUse);
                onClose();
                return;
            case "facebook":
                url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
                break;
            default:
                return;
        }

        if (url) {
            window.open(url, "_blank", "width=600,height=400");
            onClose();
        }
    };

    const platforms = [
        {
            name: "X (Twitter)",
            key: "twitter",
            icon: twitterIcon,
            color: "#000",
        },
        {
            name: "Instagram",
            key: "instagram",
            icon: instagramIcon,
            gradient: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
        },
        {
            name: "Facebook",
            key: "facebook",
            icon: facebookIcon,
            color: "#1877F2",
        },
        {
            name: "Testimonials",
            key: "testimonials",
            icon: starIcon,
            color: "#36d66b",
            disabled: true,
        },
    ];

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            centered
            className="share-certificate-modal"
            width={400}
            style={{ maxWidth: "calc(100vw - 32px)" }}
        >
            <div className="share-modal-content">
                <h2 className="share-modal-title">Share Certificate</h2>
                <p className="share-modal-subtitle">Choose a platform to share your certificate</p>

                <div className="share-platforms">
                    {platforms.map((platform) => (
                        <div
                            key={platform.key}
                            className={`share-platform-item ${platform.disabled ? "disabled" : ""}`}
                            onClick={() => !platform.disabled && handleShare(platform.key)}
                        >
                            <div
                                className="platform-icon"
                                style={{ background: platform.gradient || platform.color }}
                            >
                                <img src={platform.icon} alt={platform.name} />
                            </div>
                            <span className="platform-name">{platform.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default ShareModal;
